var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34092_14950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 15.5H15.6602L15.4812 14.8644C15.424 14.6615 15.2883 14.5042 15.173 14.3952C15.0484 14.2774 14.8939 14.1664 14.7257 14.0635C14.3879 13.8569 13.9463 13.6536 13.4512 13.4746C12.4623 13.1171 11.1957 12.8333 9.99992 12.8333C8.80844 12.8333 7.54818 13.1149 6.5613 13.4714C6.06709 13.6499 5.62577 13.8529 5.28663 14.0595C5.11759 14.1625 4.96264 14.2732 4.83695 14.3904C4.71973 14.4996 4.58598 14.6527 4.52363 14.8479L4.3153 15.5H4.99992H14.9999ZM12.1666 6.66668C12.1666 5.47387 11.1927 4.50001 9.99992 4.50001C8.80711 4.50001 7.83325 5.47387 7.83325 6.66668C7.83325 7.85949 8.80711 8.83334 9.99992 8.83334C11.1927 8.83334 12.1666 7.85949 12.1666 6.66668ZM7.16659 6.66668C7.16659 5.10115 8.43439 3.83334 9.99992 3.83334C11.5654 3.83334 12.8333 5.10115 12.8333 6.66668C12.8333 8.2322 11.5654 9.50001 9.99992 9.50001C8.43439 9.50001 7.16659 8.2322 7.16659 6.66668ZM3.83325 15C3.83325 14.6295 4.01489 14.2679 4.40114 13.9114C4.79079 13.5518 5.35439 13.2321 6.01815 12.9662C7.34646 12.4341 8.94992 12.1667 9.99992 12.1667C11.0499 12.1667 12.6534 12.4341 13.9817 12.9662C14.6454 13.2321 15.2091 13.5518 15.5987 13.9114C15.9849 14.2679 16.1666 14.6295 16.1666 15V16.1667H3.83325V15Z",
    fill: "#7100DA",
    stroke: "#7100DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34092_14950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.bf67a98388c9505efed8a6906b2b5610.svg";
export { ForwardRef as ReactComponent };